export interface ChapterMeta {
  number: number;
  title: string;
  /** Gradient stops [from, to] used for chapter-accented UI. */
  accent: readonly [string, string];
}

export const CHAPTERS: readonly ChapterMeta[] = [
  { number: 1, title: "Foundations & Authority", accent: ["#22d3ee", "#3b82f6"] },
  { number: 2, title: "On-Page SEO", accent: ["#34d399", "#22d3ee"] },
  { number: 3, title: "Off-Page SEO", accent: ["#fbbf24", "#fb7185"] },
  { number: 4, title: "Technical, Local & Mobile", accent: ["#38bdf8", "#818cf8"] },
  { number: 5, title: "Content & Keywords", accent: ["#a78bfa", "#e879f9"] },
  { number: 6, title: "SERPs, Hats & Defense", accent: ["#818cf8", "#22d3ee"] },
  { number: 7, title: "Wrap-Up", accent: ["#e879f9", "#38bdf8"] },
];

export function chapterMeta(n: number): ChapterMeta {
  const meta = CHAPTERS.find((c) => c.number === n);
  if (!meta) throw new Error(`Unknown chapter: ${n}`);
  return meta;
}
